import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../lib/api';
import { User } from '../lib/types';

export const useAdminUsers = () => {
  const queryClient = useQueryClient();

  const { data: users, isLoading } = useQuery<User[]>({
    queryKey: ['admin', 'users'],
    queryFn: async () => {
      const response = await api.get('/api/admin/users');
      return response.data;
    },
  });

  const updateUserRole = useMutation<User, Error, { id: number; role: string }>({
    mutationFn: async ({ id, role }) => {
      const response = await api.put(`/api/admin/users/${id}/role`, { role });
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin', 'users'] });
    },
  });

  return { users, isLoading, updateUserRole };
};
